import React from 'react';

import {Option, Select} from 'components/Select';
import FormField from 'components/FormField';

function SelectField(props) {
	const {
		description,
		descriptionType,
		disabled,
		id,
		selectedValue,
		onChange,
		options,
		title,
	} = props;

	function selectOption(value) {
		if (onChange) {
			onChange(id, value, title);
		}
	}

	const descriptionId = description ? `${id}-desc` : null;

	return (
		<FormField
			as="span"
			id={id}
			label={title}
			description={description}
			descriptionId={descriptionId}
			descriptionType={descriptionType}
		>
			<Select
				value={selectedValue}
				onChange={selectOption}
				size="medium"
				labelledById={id}
				aria-describedby={descriptionId}
				isDisabled={disabled}
			>
				{options.map(item => (
					<Option key={item.value} value={item.value}>
						{item.title}
					</Option>
				))}
			</Select>
		</FormField>
	);
}

export default SelectField;
